import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";
import { usePageSettings } from "../contexts/PageSettingsContext";

const useFetchColocationResources = (iataCode, isQuickBuy = false) => {
	const { changeSelectedPlan } = useSelectedPlanContext();
	const [apiError, setApiError] = useState(false);

	const fetchColocationResources = async () => {
		try {
			const quickBuyParam = isQuickBuy ? "&quickbuy=1" : "";
			const response = await fetch(
				`${process.env.GATSBY_SERVICES_ENDPOINT}colocation/resources?location=${iataCode}${quickBuyParam}`
			);

			if (!response.ok) {
				setApiError(true);
				throw new Error("Failed to fetch data");
			}
			// debugger;
			const data = await response.json();
			// Process the data and set default inputs
			if (data) {
				console.log('useFetchColocationResources: Data received', data);
				
				// Only set defaults if we're in QuickBuy mode or if no selections exist
				const shouldSetDefaults = isQuickBuy;
				
				if (shouldSetDefaults) {
					Object.keys(data).forEach((inputs) => {
						data[inputs].forEach((input) => {
							if (input.in_plan) {
								let defaultInput = {
									id: input.id,
									value: input.value,
								};

								// Check for case mismatches and set default inputs
								changeSelectedPlan((prevState) => ({
									...prevState,
									service: "colocation",
									[inputs === "prefixes"
										? "prefix"
										: inputs === "energies"
										? "energy"
										: inputs.slice(0, -1)]: defaultInput,
								}));
							}
						});
					});
				}
			}

			return data;
		} catch (error) {
			console.error("Error fetching colocation resources:", error);
			setApiError(true);
			throw error;
		}
	};

	return useQuery({
		queryKey: ["colocationResources", iataCode],
		queryFn: fetchColocationResources,
		refetchOnWindowFocus: false,
		keepPreviousData: true, // Prevent UI flicker by retaining data
		enabled: true,
	});
};

export default useFetchColocationResources;
